export default __webpack_public_path__ + "static/0244-9eca1b30c24c7f2e97dc5302bc9e1c80.png";